/* DVR - leva a escolha da vitrine para a pagina do produto. (Claude, 27/09/2026)

   O problema. Na coleção a pessoa escolhe modelagem, cor e local na barra
   fixa, e o cartão se monta com essa escolha. Ao clicar, a pagina do produto
   abria no padrao dela: quem filtrava baby look clicava numa baby look e caia
   numa unissex. A peça que abria nao era a peça que a pessoa viu.

   A ponte. A vitrine guarda a escolha em dvr:vitrine2 e este arquivo copia no
   instante do clique, antes de a navegacao acontecer. localStorage e sincrono,
   entao chega antes.

   A escolha vai em tres niveis, do mais especifico para o mais geral: o que
   esta marcado no proprio cartao clicado, depois o que a barra do topo diz, e
   o que nao estiver em nenhum dos dois fica como a pessoa tinha deixado.

   dvr:vitrine  -> motor da camiseta, que conhece unissex e baby look
   dvr:ove      -> chave do dvr-ove.js, o motor que eu escrevi acreditando que a
                   pagina do oversized era movida por ele. Nao e. Continua sendo
                   escrita porque nao apago nada, mas quem resolve e o recado
   dvr:abre     -> recado de uma vez so para o dvr-abre.js. Escrever chave nao
                   bastava: a pagina do produto e movida pelo sistema vf, que
                   nao guarda escolha e abre sempre em Unissex, Frente, Branco.
                   Quem cumpre o recado la clica nos botoes da propria pagina.

   Nenhum motor foi tocado. Sem a chave da vitrine, este arquivo nao faz nada.
*/
(function () {
'use strict';

var DA_VITRINE = 'dvr:vitrine2';
var CAMISETA = 'dvr:vitrine';
var OVERSIZED = 'dvr:ove';
var RECADO = 'dvr:abre';
var LOCAIS = { Frente: 1, Peito: 1, Costas: 1 };

function escolha() {
  try {
    var s = JSON.parse(localStorage.getItem(DA_VITRINE) || 'null');
    return (s && s.mod) ? s : null;
  } catch (e) { return null; }
}

/* junta em vez de sobrescrever: o que a vitrine nao decide fica como estava */
function junta(chave, campos) {
  var vazio = true, k;
  for (k in campos) if (campos.hasOwnProperty(k)) { vazio = false; break; }
  if (vazio) return;
  try {
    var atual = {};
    try { atual = JSON.parse(localStorage.getItem(chave) || '{}') || {}; } catch (e) { atual = {}; }
    if (!atual || typeof atual !== 'object') atual = {};
    for (k in campos) if (campos.hasOwnProperty(k)) atual[k] = campos[k];
    localStorage.setItem(chave, JSON.stringify(atual));
  } catch (e) {}
}

/* so peca do vestuario. O mapa de artes que a vitrine publica e a lista de
   quem tem estampa, entao ele serve de porteiro: link de menu para um vidro de
   gotas nao mexe na escolha da camiseta. */
function doVestuario(destino) {
  var p = (destino || '').split('/products/')[1] || '';
  var h = p.split('?')[0].split('#')[0].split('/')[0];
  if (!h) return false;
  if (h.indexOf('oversized-') === 0) return true;
  var cfg = window.DVR_V2CFG || window.DVR_VITRINE || window.DVR_OVECFG;
  if (!cfg || !cfg.artes) return false;
  for (var i = 0; i < cfg.artes.length; i++) {
    if (String(cfg.artes[i][0]) === h) return true;
  }
  return false;
}

/* A ESCOLHA DO CARTAO GANHA DA ESCOLHA DA BARRA.
   A barra do topo guarda a escolha geral em dvr:vitrine2, mas cada cartao tem
   a escolha DELE, que o motor mantem so na memoria: mexer na cor de um cartao
   nao mexe na chave global. Entao quem clica num cartao rosa e cai numa peca
   branca. O estado do cartao esta no DOM, marcado com .on, e e de la que eu
   leio: .dv2-cor guarda a cor em data-cor e .dv2-pz guarda o local em
   data-pos. Sem cartao, ou sem marca nele, vale a barra. */
function doCartao(a) {
  var cartao = a && a.closest ? (a.closest('.dv-card') || a.closest('li') || a.parentNode) : null;
  if (!cartao || !cartao.querySelector) return null;
  var bc = cartao.querySelector('.dv2-cor.on');
  var bp = cartao.querySelector('.dv2-pz.on');
  if (!bc && !bp) return null;
  var r = {};
  if (bc) r.cor = bc.getAttribute('data-cor') || null;
  if (bp) r.loc = bp.getAttribute('data-pos') || null;
  return r;
}

function leva(destino, a) {
  if (!doVestuario(destino)) return;
  var s = escolha();
  if (!s) return;
  var doCard = doCartao(a) || {};
  var loc = LOCAIS[doCard.loc] ? doCard.loc : (LOCAIS[s.loc] ? s.loc : null);
  var cor = (typeof doCard.cor === 'string' && doCard.cor) ? doCard.cor
          : ((typeof s.cor === 'string' && s.cor) ? s.cor : null);
  var ove = s.mod === 'ove' || (destino || '').indexOf('/products/oversized-') !== -1;

  if (ove) {
    var c1 = {};
    if (loc) c1.loc = loc;
    if (cor) c1.cor = cor;
    junta(OVERSIZED, c1);
    /* 28/09: aqui faltava o recado, e foi o MESMO erro de raiz que eu ja tinha
       cometido: eu escrevia na chave do dvr-ove.js acreditando que a pagina do
       oversized tinha motor proprio. Nao tem. Ela e movida pelo sistema vf,
       igual a da camiseta, e quem traduz recado em clique e o dvr-abre.js.
       Sem esta linha, quem escolhia roxo nas costas na grade filtrada por
       oversized abria a peca em branco na frente.
       A chave do motor antigo continua sendo escrita acima, de proposito: nao
       apago nada que possa estar servindo em outro lugar. */
    var c3 = { mod: 'ove' };
    if (loc) c3.loc = loc;
    if (cor) c3.cor = cor;
    try { localStorage.setItem(RECADO, JSON.stringify(c3)); } catch (e) {}
    return;
  }
  /* modalidade que ainda nao tem motor (moletom): nao mexe em nada */
  if (s.mod !== 'uni' && s.mod !== 'bab') return;
  var c2 = { mod: s.mod };
  if (loc) c2.loc = loc;
  if (cor) c2.cor = cor;
  junta(CAMISETA, c2);
  /* e o recado de uma vez so, que o dvr-abre.js cumpre clicando nos botoes
     da pagina. Escrever a chave nao bastava: a pagina do produto e movida
     pelo sistema vf, que nao le chave nenhuma. */
  try { localStorage.setItem(RECADO, JSON.stringify(c2)); } catch (e) {}
}

function cartao(ev) {
  var t = ev.target;
  if (t && t.nodeType === 3) t = t.parentNode;
  if (!t || !t.closest) return null;
  return t.closest('a[href*="/products/"]');
}

function ouve(ev) {
  var a = cartao(ev);
  if (a) leva(a.getAttribute('href') || '', a);
}

/* captura, para chegar antes de qualquer handler que navegue por conta propria.
   auxclick cobre o clique do meio, que abre em outra aba. */
document.addEventListener('click', ouve, true);
document.addEventListener('auxclick', ouve, true);
})();